module.exports = __webpack_public_path__ + "static/media/tiles.926441ef.jpg";